import { IPayloadCreateSchool } from 'app/api/school/model'
import R from 'app/assets/R'
import { IRefModal } from 'app/components/common/ModalComponent'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { notificationController } from 'app/controllers/notification-controller'
import { useCreateSchool } from 'app/react-query/hook/school'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

export const useHook = () => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm<IPayloadCreateSchool>()
  const modalRef = useRef<IRefModal>({})

  const { mutateAsync: mutateAsyncCreate, isLoading } = useCreateSchool()

  const handleSubmit = async (values: IPayloadCreateSchool) => {
    const res = await mutateAsyncCreate?.(values)
    if (res) {
      modalRef?.current?.hide?.()
      form?.resetFields()
      notificationController.success({
        message: t(R.strings.success),
      })
    }
  }

  return {
    form,
    modalRef,
    handleSubmit,
    isLoading,
  }
}
